var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.59619 6.11091C5.40093 5.91565 5.40093 5.59907 5.59619 5.40381C5.79146 5.20854 6.10804 5.20854 6.3033 5.40381L10.1924 9.29289L14.0815 5.40381C14.2767 5.20854 14.5933 5.20854 14.7886 5.40381C14.9838 5.59907 14.9838 5.91565 14.7886 6.11091L10.8995 10L14.7886 13.8891C14.9838 14.0843 14.9838 14.4009 14.7886 14.5962C14.5933 14.7915 14.2767 14.7915 14.0815 14.5962L10.1924 10.7071L6.3033 14.5962C6.10804 14.7915 5.79146 14.7915 5.59619 14.5962C5.40093 14.4009 5.40093 14.0843 5.59619 13.8891L9.48528 10L5.59619 6.11091Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3537dd46f58f692d98a3b1af2342634a.svg";
export { ForwardRef as ReactComponent };